export default __webpack_public_path__ + "static/media/6.3886a6df.png";